export default __webpack_public_path__ + "static/media/thumb_down.81c6a76a.svg";